import { save, read } from "../storage";
import { user } from "../stored";
import {
  STORE_KEY_DASHBOARD_FILTER,
  STORE_KEY_MYCONTACTS_FILTER,
  STORE_KEY_CODREPORT_FILTER,
  STORE_KEY_INVOICES_FILTER,
  STORE_KEY_INVOICE_FILTER,
  STORE_KEY_WMS_PRODUCTS_FILTER,
  STORE_KEY_WMS_ORDERS_FILTER,
  STORE_KEY_CONSUMABLES_PRODUCTS,
  STORE_KEY_CONSUMABLES_ORDERS,
  STORE_KEY_SHIPMENT_FILTER,
  STORE_KEY_REQUEST_PREFS,
  STORE_KEY_EXPORT_TEMPLATE,
  STORE_KEY_USERNAME,
  STORE_KEY_COMPANY
} from "../constants";

const state = {
  user: user,
  company: null,
  dashboardFilter: null,
  myContactFilter: null,
  codReportFilter: null,
  invoicesFilter: null,
  invoiceFilter: null,
  wmsProductsFilter: null,
  wmsOrdersFilter: null,
  consumablesProducts: null,
  shipmentFilter: null,
  requestPrefs: null,
  exportTemplate: null
};

const mutations = {
  UPDATE_CONFIG_PRINCIPAL(state, user) {
    state.user = user || state.user;
  },
  UPDATE_COMPANY(state, company) {
    state.company = company || state.company;
  },
  UPDATE_DASHBOARD(state, filter) {
    state.dashboardFilter = filter || state.dashboardFilter;
  },
  UPDATE_MY_CONTACTS(state, filter) {
    state.myContactFilter = filter || state.myContactFilter;
  },
  UPDATE_COD_REPORT(state, filter) {
    state.codReportFilter = filter || state.codReportFilter;
  },
  UPDATE_INVOICES(state, filter) {
    state.invoicesFilter = filter || state.invoicesFilter;
  },
  UPDATE_INVOICE(state, filter) {
    state.invoiceFilter = filter || state.invoiceFilter;
  },
  UPDATE_WMS_PRODUCTS(state, filter) {
    state.wmsProductsFilter = filter || state.wmsProductsFilter;
  },
  UPDATE_WMS_ORDERS(state, filter) {
    state.wmsOrdersFilter = filter || state.wmsOrdersFilter;
  },
  UPDATE_CONSUMABLES_PRODUCTS(state, filter) {
    state.consumablesProducts = filter || state.consumablesProducts;
  },
  UPDATE_CONSUMABLES_ORDERS(state, filter) {
    state.consumablesOrders = filter || state.consumablesOrders;
  },
  UPDATE_SHIPMENT(state, filter) {
    state.shipmentFilter = filter || state.shipmentFilter;
  },
  UPDATE_REQUEST_PREFS(state, data) {
    state.requestPrefs = data || state.requestPrefs;
  },
  UPDATE_EXPORT_TEMPLATE(state, data) {
    state.exportTemplate = data || state.exportTemplate;
  }
};

const actions = {
  setUserConfigPrincipal({ commit, state }, user) {
    let diff = !!user && state.user !== user;
    // console.log(
    //   "Update user config principal " +
    //     state.user +
    //     " vs " +
    //     user +
    //     " diff=" +
    //     diff
    // );
    save(STORE_KEY_USERNAME, user);
    commit("UPDATE_CONFIG_PRINCIPAL", user);

    if (!!user) {
      try {
        let//
        val = read(user + "." + STORE_KEY_COMPANY);
        val = (val) ? JSON.parse(val) : null;
        commit("UPDATE_COMPANY", val);
      } catch(e) {
        //
      }

      state.dashboardFilter = read(user + "." + STORE_KEY_DASHBOARD_FILTER) || JSON.stringify({
        dataFilter: "30",
        dataSegregation: "by_date",
        dateSince: new Date().setMonth(new Date().getMonth() - 1),
        dateUntil: new Date().valueOf()
      });

      state.myContactFilter = read(user + "." + STORE_KEY_MYCONTACTS_FILTER) || JSON.stringify({
        search: "",
        pagination: null,
        shown: []
      });

      state.codReportFilter = read(user + "." + STORE_KEY_CODREPORT_FILTER) || JSON.stringify({
        dataFilter: "30",
        dateSince: new Date().setMonth(new Date().getMonth() - 4),
        dateUntil: new Date().valueOf(),
        pagination: null,
        shown: []
      });

      state.invoicesFilter = read(user + "." + STORE_KEY_INVOICES_FILTER) || JSON.stringify({
        dataFilter: "30",
        dateSince: new Date().setMonth(new Date().getMonth() - 12),
        dateUntil: new Date().valueOf(),
        pagination: null,
        shown: []
      });

      state.invoiceFilter = read(user + "." + STORE_KEY_INVOICE_FILTER) || JSON.stringify({
        pagination: null,
        shown: []
      });

      state.wmsProductsFilter = read(user + "." + STORE_KEY_WMS_PRODUCTS_FILTER) || JSON.stringify({
        pagination: null,
        headersdata: []
      });

      state.wmsOrdersFilter = read(user + "." + STORE_KEY_WMS_ORDERS_FILTER) || JSON.stringify({
        pagination: null,
        headersdata: []
      });

      // Consumables
      state.consumablesProducts = read(user + "." + STORE_KEY_CONSUMABLES_PRODUCTS) || JSON.stringify({
        pagination: null,
        headersdata: []
      });
      state.consumablesOrders = read(user + "." + STORE_KEY_CONSUMABLES_ORDERS) || JSON.stringify({
        pagination: null,
        headersdata: []
      });

      state.shipmentFilter = read(user + "." + STORE_KEY_SHIPMENT_FILTER) || JSON.stringify({
        pagination: null,
        shown: []
      });

      state.requestPrefs = read(user + "." + STORE_KEY_REQUEST_PREFS) || JSON.stringify({
        priceBox: null
      });

      state.exportTemplate = read(user + "." + STORE_KEY_EXPORT_TEMPLATE) || JSON.stringify([
        "target.partner",
        "target.address.post_code",
        "target.contact_person",
        "target.contact_phone",
        "contents[0].count",
        "contents[0].weight",
        "description"
      ]);
    } else {
      state.company = null;
      state.dashboardFilter = null;
      state.myContactFilter = null;
      state.codReportFilter = null;
      state.invoicesFilter = null;
      state.invoiceFilter = null;
      state.wmsProductsFilter = null;
      state.wmsOrdersFilter = null;
      state.consumablesProducts = null;
      state.consumablesOrders = null;
      state.shipmentFilter = null;
      state.requestPrefs = null;
      state.exportTemplate = null;
    }
  },
  updateCompany({commit, state}, company) {
    commit("UPDATE_COMPANY", company);
    if (state.user) {
      save(state.user + "." + STORE_KEY_COMPANY, JSON.stringify(company));
    }
  },
  updateDashboardFilter({ commit, state }, filter) {
    if (state.user) {
      commit("UPDATE_DASHBOARD", filter);
      save(state.user + "." + STORE_KEY_DASHBOARD_FILTER, filter);
    }
  },
  updateMyContactFilter({ commit, state }, filter) {
    if (state.user) {
      commit("UPDATE_MY_CONTACTS", filter);
      save(state.user + "." + STORE_KEY_MYCONTACTS_FILTER, filter);
    }
  },
  updateCodReportFilter({ commit, state }, filter) {
    if (state.user) {
      commit("UPDATE_COD_REPORT", filter);
      save(state.user + "." + STORE_KEY_CODREPORT_FILTER, filter);
    }
  },
  updateInvoicesFilter({ commit, state }, filter) {
    if (state.user) {
      commit("UPDATE_INVOICES", filter);
      save(state.user + "." + STORE_KEY_INVOICES_FILTER, filter);
    }
  },
  updateSingleInvoiceFilter({ commit, state }, filter) {
    if (state.user) {
      commit("UPDATE_INVOICE", filter);
      save(state.user + "." + STORE_KEY_INVOICE_FILTER, state.invoiceFilter);
    }
  },
  updateWmsProductsFilter({ commit, state }, filter) {
    if (state.user) {
      commit("UPDATE_WMS_PRODUCTS", filter);
      save(state.user + "." + STORE_KEY_WMS_PRODUCTS_FILTER, state.wmsProductsFilter);
    }
  },
  updateWmsOrdersFilter({ commit, state }, filter) {
    if (state.user) {
      commit("UPDATE_WMS_ORDERS", filter);
      save(state.user + "." + STORE_KEY_WMS_ORDERS_FILTER, state.wmsOrdersFilter);
    }
  },
  updateConsumablesProducts({ commit, state }, filter) {
    if (state.user) {
      commit("UPDATE_CONSUMABLES_PRODUCTS", filter);
      save(state.user + "." + STORE_KEY_CONSUMABLES_PRODUCTS, state.consumablesProducts);
    }
  },
  updateConsumablesOrders({ commit, state }, filter) {
    if (state.user) {
      commit("UPDATE_CONSUMABLES_ORDERS", filter);
      save(state.user + "." + STORE_KEY_CONSUMABLES_ORDERS, state.consumablesOrders);
    }
  },
  updateShipmentFilter({ commit, state }, filter) {
    if (state.user) {
      commit("UPDATE_SHIPMENT", filter);
      save(state.user + "." + STORE_KEY_SHIPMENT_FILTER, state.shipmentFilter);
    }
  },
  updateRequestPrefs({ commit, state }, data) {
    if (state.user) {
      commit("UPDATE_REQUEST_PREFS", data);
      save(state.user + "." + STORE_KEY_REQUEST_PREFS, state.requestPrefs);
    }
  },
  updateExportTemplate({ commit, state }, data) {
    if (state.user) {
      commit("UPDATE_EXPORT_TEMPLATE", data);
      save(state.user + "." + STORE_KEY_EXPORT_TEMPLATE, state.exportTemplate);
    }
  }
};

const getters = {
  currentUsername(state) {
    return state.user;
  },
  currentCompany(state) {
    return state.company;
  },
  dashboardFilter(state) {
    return state.dashboardFilter;
  },
  contactsFilter(state) {
    return state.myContactFilter;
  },
  codReportFilter(state) {
    return state.codReportFilter;
  },
  invoicesFilter(state) {
    return state.invoicesFilter;
  },
  singleInvoiceFilter(state) {
    return state.invoiceFilter;
  },
  wmsProductsFilter(state) {
    return state.wmsProductsFilter;
  },
  wmsOrdersFilter(state) {
    return state.wmsOrdersFilter;
  },
  consumablesProducts() {
    return state.consumablesProducts;
  },
  consumablesOrders() {
    return state.consumablesOrders;
  },
  shipmentFilter(state) {
    return state.shipmentFilter;
  },
  requestPrefs(state) {
    return state.requestPrefs;
  },
  exportTemplate(state) {
    return state.exportTemplate;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};